/**
 * TransactionSection · txn kit (presentation only)
 * A titled card that structures one logical step of a transaction. Optional
 * step index badge drives the information hierarchy. No logic.
 */
import React from "react";

export default function TransactionSection({
  index,
  title,
  subtitle,
  right = null,
  className = "",
  bodyClassName = "p-4",
  testId,
  children,
}) {
  return (
    <section
      data-testid={testId}
      className={`rounded-md border border-[var(--border)] bg-[var(--bg-1)] ${className}`}
    >
      <header className="flex items-center justify-between gap-3 px-4 py-2.5 border-b border-[var(--border)]">
        <div className="flex items-center gap-2.5 min-w-0">
          {index !== undefined && index !== null && (
            <span className="flex-shrink-0 w-5 h-5 rounded-sm bg-[var(--bg-2)] text-[var(--fg-2)] text-[10px] font-mono font-semibold flex items-center justify-center">
              {index}
            </span>
          )}
          <div className="min-w-0">
            <div className="font-display text-sm font-bold tracking-tight text-[var(--fg-0)] truncate">
              {title}
            </div>
            {subtitle && <div className="text-[11px] text-[var(--fg-3)] truncate">{subtitle}</div>}
          </div>
        </div>
        {right && <div className="flex items-center gap-2 flex-shrink-0">{right}</div>}
      </header>
      <div className={bodyClassName}>{children}</div>
    </section>
  );
}
